import { type Loadable, initLoadable } from '@/loadingUtils'
import type { Study, Teach } from '@pocketprep/types'

export interface IInstructorModuleState {
    currentOrgInstructorId: string | null
    currentOrgInstructors: { [key: string]: Loadable<{ [key: string]: Teach.Class.OrgInstructorJSON }> | undefined }
    currentOrgInstructorUsers: { [key: string]: Loadable<{ [key: string]: Study.Class.UserJSON }> | undefined }
    currentUserOrgInstructors: Loadable<Teach.Class.OrgInstructorJSON[]>
}

export const getInitialInstructorState = (): IInstructorModuleState => {
    return {
        currentOrgInstructorId: null,
        currentOrgInstructors: {},
        currentOrgInstructorUsers: {},
        currentUserOrgInstructors: initLoadable([]),
    }
}

const moduleState = getInitialInstructorState()

export default moduleState
